import React from "react";
import RedirectingPage from "./RedirectingPage";

const Parciales = () => (
  <RedirectingPage url="https://app.copywriteeducacion.com/public/forms/partial" />
);

export default Parciales;
